import React from 'react';
import ToggleButtonGroup from '@creditflowresearch/uilib/ToggleButtonGroup';
import { IToggleGroup } from './IToggleGroup';

import styles from './HeaderChart.module.scss';

interface IProps {
  title: string,
  groups: IToggleGroup[],
}

const HeaderChart = ({ title, groups }: IProps): React.ReactElement => (
  <div className={ styles.issueChartHeaderMultiRowContainer }>
    <div className={ styles.issueChartTitle }>
      <h3>{ title }</h3>
    </div>

    <div className={ styles.issueChartButtonsContainer }>
      {
        groups.map(({ dataTest, value, onChange, options }) => (
          <ToggleButtonGroup
            key={ dataTest }
            value={ [value] }
            onChange={ onChange }
            size="XS"
            dataTest={ dataTest }
          >
            {
              options.map(({ value: optionValue, title: optionTitle, dataTest: optionDataTest }) => (
                <ToggleButtonGroup.Item
                  key={ optionDataTest }
                  value={ optionValue }
                  dataTest={ optionDataTest }
                >
                  { optionTitle }
                </ToggleButtonGroup.Item>
              ))
            }
          </ToggleButtonGroup>
        ))
      }
    </div>
  </div>
);

export default HeaderChart;
